import { ShelfTalkerMenu } from './shelf-talker-menu';
import { FONT, FontStyleSheet } from '../font-style-sheets';
import { AssetLibraryType } from '../../enum/dto/asset-library-type.enum';

export class DougShelfTalkerMenu extends ShelfTalkerMenu {
  whatFontsAreNeededToRenderContent(): FontStyleSheet[] {
    return [FONT.Poppins.Regular_400, FONT.Poppins.Medium_500, FONT.Poppins.SemiBold_600, FONT.Poppins.Bold_700];
  }

  override getAdobeFontFamilyCssUrl(): string | null {
    return 'https://use.typekit.net/aox5jqq.css';
  }

  shouldFetchVariantAssets(): boolean {
    return true;
  }

  override variantAssetTypeSortOrder(): string[] {
    return [AssetLibraryType.PrimaryBrand, AssetLibraryType.AlternateBrand, AssetLibraryType.Brand];
  }
}
